import { render, staticRenderFns } from "./updateModal.vue?vue&type=template&id=64683b08&"
import script from "./updateModal.vue?vue&type=script&lang=js&"
export * from "./updateModal.vue?vue&type=script&lang=js&"
import style0 from "vue-color-gradient-picker/dist/index.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updateModal.vue?vue&type=style&index=1&id=64683b08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports